'use strict';

common.View.create('website::partials.Menu', {
    onDOMLoad() {
        // Init MMenu?
        if (this.isMmenu()) this.initMmenu();
    },

    isMmenu() {
        return this.element.data('style') === 'mmenu';
    },

    initMmenu() {
        // Init MMenu.
        let mmenu = this.element.mmenu({
            extensions: [
                'position-back',
                'position-right',
                'pagedim-black',
                'theme-white',
                'fx-menu-slide',
                'fx-panels-slide-100',
            ],
        });

        let hamburger = $('.hamburger');
        let API = mmenu.data('mmenu');

        hamburger.on('click', function () {
            API.open();
        });

        API.bind('open:start', function () {
            setTimeout(function () {
                hamburger.addClass('is-active');
            }, 100);
        });
        API.bind('close:start', function () {
            setTimeout(function () {
                hamburger.removeClass('is-active');
            }, 100);
        });
    },
});
